import React, { ReactNode } from 'react';
import style from './styles.module.css';
import { IoCloseSharp } from 'react-icons/io5';
import { Icon } from '../Icon';

export interface DrawerFeedbackFormProps {
  drawerTitle: string;
  drawerSubtitle: string;
  serviceTitle: string;
  secretary: string;
  children: ReactNode;
  openDrawer: boolean;
  setOpenDrawer: (value: React.SetStateAction<boolean>) => void;
}

export const DrawerFeedbackForm: React.FC<DrawerFeedbackFormProps> = ({
  drawerTitle,
  drawerSubtitle,
  serviceTitle,
  secretary,
  children,
  openDrawer,
  setOpenDrawer,
}) => {
  return (
    <div
      className={`${style.drawerContainer} ${
        openDrawer ? style.open : style.close
      }`}
    >
      <div className={style.drawerHeader}>
        <div className={style.drawerHeaderInfo}>
          <div>
            <h2>{drawerTitle}</h2>
            <p>{drawerSubtitle}</p>
          </div>

          <button
            type="button"
            aria-label="Fechar"
            onClick={() => setOpenDrawer(false)}
          >
            <Icon icon={IoCloseSharp} color="#fff" size={24} />
          </button>
        </div>

        <div className={style.drawerServiceCardInfo}>
          <p>{serviceTitle}</p>
          <div className={style.drawerHeaderInfoSubTitle}>
            <hr />
            <p>{secretary}</p>
          </div>
        </div>
      </div>

      <div className={style.drawerContent}>{children}</div>
    </div>
  );
};
